// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"812":"chatRoom","969":"sharing"}[chunkId] || chunkId) + "." + {"248":"5c93a695","812":"a7af8fa8","969":"5f6ee225"}[chunkId] + ".js";
};